

function Cancel() {
    return (
        <div className="cancelPaymentContainer">
            <h2>Cancelled Payment</h2>
            <p>Your payment has been cancelled.</p>
        </div>
    )
}

export default Cancel;